const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Assignments Manager Directive to display a list or table with tracks to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('editAssignment', ['Application', 'Assignments', 'Features', function (Application, Assignments, Features) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      assignmentId: '=',
      close: '&'
    },
    template: require('../../../templates/directives/assignments/edit-assignment.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.tab = 'settings';
      self.assignmentTemplates = Features.flags().enable_assignment_templates;

      self.addMessage = function(message) {
        // check if already in non_reminder_messages or reminder messages
        // check if type is appropriate for place
        // add to correct place
        var messageType = message.type.indexOf('reminder') !== -1 ? 'rm' : message.type.indexOf('overdue') !== -1 ? 'om' : 'nrm';
        var nrmPlace = self.settings.non_reminder_messages.indexOf(message._id);
        var rmPlace = -1;
        let omPlace = -1;
        for (var i = 0; i < self.settings.reminder_messages.length; i++) {
          if (self.settings.reminder_messages[i].message === message._id) {
            rmPlace = i;
            break;
          }
        }
        for (const [i, om] of self.settings.overdue_messages.entries()) {
          if (om.message === message._id) {
            omPlace = i;
            break;
          }
        }

        if (messageType === 'nrm') {
          if (nrmPlace === -1) {
            self.settings.non_reminder_messages.push(message._id);
          }
          if (rmPlace !== -1) {
            self.settings.reminder_messages.splice(rmPlace, 1);
          }
          if (omPlace !== -1) {
            self.settings.overdue_messages.splice(omPlace, 1);
          }
        }

        if (messageType === 'rm') {
          if (rmPlace === -1) {
            self.settings.reminder_messages.push({
              message:message._id,
              time_before_due: message.time_before_due
            });
          } else {
            self.settings.reminder_messages[rmPlace] = {
              message:message._id,
              time_before_due: message.time_before_due
            };
          }
          if (nrmPlace !== -1) {
            self.settings.non_reminder_messages.splice(nrmPlace, 1);
          }
          if (omPlace !== -1) {
            self.settings.overdue_messages.splice(omPlace, 1);
          }
        }

        if (messageType === 'om') {
          const overdueMessage = {
            message: message._id,
            cadence: message.cadence,
            total_messages: message.total_messages,
          };
          if (omPlace === -1) {
            self.settings.overdue_messages.push(overdueMessage);
          } else {
            self.settings.overdue_messages[omPlace] = overdueMessage;
          }
          if (rmPlace !== -1) {
            self.settings.reminder_messages.splice(rmPlace, 1);
          }
          if (nrmPlace !== -1) {
            self.settings.non_reminder_messages.splice(nrmPlace, 1);
          }
        }

        self.update(true);
      };

      self.close = function(refresh) {
        $scope.close({changed: refresh});
      };

      self.update = function(silent) {
        self.saving = true;
        var body = {
          escalation_contacts: self.settings.escalation_contacts || [],
          non_reminder_messages: self.settings.non_reminder_messages || [],
          reminder_messages: self.settings.reminder_messages || [],
          overdue_messages: self.settings.overdue_messages || [],
        };

        var date = new moment();
        var diff;
        var sent_removals = [];
        if (!self.settings.use_due) {
          body.remove_due = true;
          body.incomplete = false;
        }

        if (
          self.settings.use_due &&
          (!self.original_due || self.settings.due_date !== self.original_due)
        ) {
          if (self.original_due_date) {
            date = moment(self.original_due_date);
          }
          var diff = self.settings.due_date - (self.original_due || 0);
          body.due_date = new Date(date.add(diff, 'days').valueOf());
          body.incomplete = false;
        }

        if (
          self.settings.use_due &&
          self.settings.due_date &&
          self.settings.reminder_messages &&
          self.settings.reminder_messages.length
        ) {
          self.settings.reminder_messages.forEach(function (item) {
            if (item.time_before_due <= self.settings.due_date) {
              sent_removals.push(item.message);
            }
          });
        }

        if (sent_removals.length) {
          body.remove_sent_messages = sent_removals;
        }

        Assignments.update({subresource: self.settings._id}, body).$promise.then(function(results) {
          if (!silent) {
            self.close(true);
          }
          self.saving = false;
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', text: 'There was an error in updating this assignment.', duration: 5});
          self.saving = false;
        });
      };

      self.original_due = false;
      self.original_due_date = false;
      self.initialize = function() {
        Assignments.get({
          subresource: $scope.assignmentId,
          fields: 'assignee,completed,incomplete,completed_date,due_date,assigned_content,completed_content,track,article,media,scorm,imported_content,assessment,createdAt,escalation_contacts,non_reminder_messages,reminder_messages,escalate_manager,escalate_buddy,require_recompletion,overdue_messages',
          'assigned_content.content_id-populate': 'name,title,type',
          'track-populate': 'name,title,type',
          'article-populate': 'title,type',
          'media-populate': 'title,type',
          'scorm-populate': 'title,type',
          'assessment-populate': 'title,type',
          'imported_content-populate': 'title,type',
          'assignee-populate': 'first_name,last_name,full_name,email'
        }).$promise.then(function(assignment) {
          self.hasNotifications = (assignment.non_reminder_messages && assignment.non_reminder_messages.length) || (assignment.reminder_messages && assignment.reminder_messages.length) || (assignment.overdue_messages && assignment.overdue_messages.length) ? true : false;
          self.settings = assignment;
          if (assignment.due_date) {
            self.original_due_date = assignment.due_date;
            self.settings.due_date = Math.ceil(moment.duration(moment(assignment.due_date).diff(moment())).asDays());
            self.settings.use_due = assignment.due_date ? true : false;
            self.original_due = self.settings.due_date;
          }
          self.content = [];
          if (assignment.assigned_content && assignment.assigned_content.length) {
            assignment.assigned_content.forEach(function(item) {
              if (!item.content_id) {
                return;
              }
              self.content.push(item.content_id);
            });
          }
          var options = ['track', 'article', 'media', 'scorm', 'assessment', 'imported_content'];
          options.forEach(function(opt) {
            if (assignment[opt]) {
              self.content.push(assignment[opt]);
            }
          });
        });
      };

      self.initialize();

    }],
    controllerAs: 'edit'
  };
}]);